<template>
	<main>
		<HeaderTab :title="getTrad('monte.contract_list')">
			<template #actions>
				<div class="d-flex align-items-center" style="gap:0.5rem">
					<!-- Filtres saison + client : visibles uniquement sur desktop (md+) -->
					<b-form-select
						v-if="season_options.length > 1"
						v-model="season_selected"
						:options="season_options"
						size="sm"
						style="width:auto"
						class="d-none d-md-block"
					/>
					<b-form-select
						v-if="show_tiers_filter"
						v-model="tiers_selected"
						:options="all_tiers_options"
						size="sm"
						style="width:auto;max-width:180px"
						class="d-none d-md-block"
					/>
					<b-button :to="{ name: 'ContractNew' }" tag="router-link" variant="primary" size="sm">
						{{ $t('action.ajouter_contract') }} <font-awesome-icon :icon="['fal', 'plus']"/>
					</b-button>
				</div>
			</template>
		</HeaderTab>

		<div id="content">
			<div class="container-fluid">
				<!-- Filtres saison + client : visibles uniquement sur mobile -->
				<div v-if="season_options.length > 1 || show_tiers_filter" class="d-flex d-md-none align-items-center flex-wrap pt-2 pb-1" style="gap:0.5rem">
					<b-form-select
						v-if="season_options.length > 1"
						v-model="season_selected"
						:options="season_options"
						size="sm"
						style="width:auto"
					/>
					<b-form-select
						v-if="show_tiers_filter"
						v-model="tiers_selected"
						:options="all_tiers_options"
						size="sm"
						style="width:auto;max-width:180px"
					/>
				</div>
				<div class="row">
					<div class="col-12">
						<List
							ref="list"
							from="list"
							:season_filter="season_selected"
							:tiers_filter="tiers_selected"
							@filters-ready="onFiltersReady"
						/>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
	export default {
		name: "ContractList",
		data() {
			return {
				season_options: [],
				all_tiers_options: [],
				season_selected: null,
				tiers_selected: null,
				show_tiers_filter: false,
			}
		},
		methods: {
			onFiltersReady({ season_options, all_tiers_options, season_selected, uniqueTiersCount }) {
				// Convertit en format { value, text } pour b-form-select
				// all_tiers_options inclut déjà l'entrée "Tous clients" (tiers_id: null) depuis ListV2
				this.season_options = season_options.map(o => ({ value: o.value, text: o.label }))
				this.all_tiers_options = all_tiers_options.map(o => ({ value: o.tiers_id, text: o.tiers_rs }))
				this.season_selected = season_selected ? season_selected.value : null
				this.show_tiers_filter = uniqueTiersCount > 1
				this.tiers_selected = null
			}
		},
		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
			List: () => import('@/components/Contract/ListV2'),
		},
	}
</script>
